// extracted by mini-css-extract-plugin
export default {"container":"HorizontalWallet_container__UIDWm","title":"HorizontalWallet_title__CTzYL"};